import React from "react"
import types from "prop-types"
import { XIcon } from "shared/icons"

const CloseModalButton = ({ closeModal, buttonLabel = "close modal" }) => (
  <button
    className="absolute -top-4 right-4 p-3"
    onClick={closeModal}
    aria-label={buttonLabel}
  >
    <XIcon
      className="rounded-full bg-primary-light p-2 h-8 w-8"
      ariaHidden
    />
  </button>
)

CloseModalButton.propTypes = {
  closeModal: types.func.isRequired,
  buttonLabel: types.string,
}

export default CloseModalButton
